/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Observable } from 'rxjs';
import { ChartData } from '../common/chart';

export abstract class ProfitBarAnimationChartData {
  abstract getChartData(): Observable<ChartData>;
}
